import React, { useState, useEffect, useRef, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  setUserActions,
  setRegionActions,
  setTheInternalDepartmentlevelusersCreatedActions,
  setTheInternalDepartmentRetreve_usersActions,
  setTheInternalDepartmentEdtions_usersActions,
  setGeoLoactionStateAction,
} from "../../../../Redux/Slice";
import { useNavigate } from "react-router-dom";
import LImages from "../../../../Assets/AppComponent/Union (15).svg";
import closebtnimg from "../../../../Assets/AppComponent/Group 427320024.svg";
import dropdownimg from "../../../../Assets/AppComponent/Vector (22).svg";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useDebouncedEffect from "use-debounced-effect";

const DepartmentLevelUser = (props) => {
  const { currentPage, setShow, show, EditId, getsearch, LevelUsersSelected } =
    props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const state = useSelector((state) => state);
  const [RegionOptions, setOptions2] = useState([]);
  const [regionValues, setregionValues] = useState([]);

  const Swal = require("sweetalert2");
  const navigator = useNavigate();
  const initialStateSearch = {
    categorySearch: "",
    usersearh: "",
    regionSearch: "",
    stateSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);

  const initialDebouanceSearch = {
    categorySearch: "",
    usersearh: "",
    regionSearch: "",
    stateSearch: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch
  );

  const dispatch = useDispatch();

  const createnewuser = {
    department_name: "",
    description: "",
    l1_user: [],
    l2_user: [],
    l3_user: [],

    l1_time_type: "",
    l2_time_type: "",
    l3_time_type: "",

    l1_user_TAT: "",
    l2_user_TAT: "",
    l3_user_TAT: "",
    // issue_ids: [],
    incharge_ids: [],
    region_id: "",
    department_id: state.NeededdatasListed.SubQueryIDs,
    state_id: "",
  };

  const [data, setData] = useState(createnewuser);

  ///----Ticketing -----L Details
  var DurationOpions = [
    {
      value: "0",
      label: "Minutes",
    },
    {
      value: "1",
      label: "Hours",
    },
    {
      value: "2",
      label: "Day",
    },
  ];

  const [DurationOneval, setDurationoneval] = useState([]);
  const [DurationTwoval, setDurationtwoval] = useState([]);
  const [stateEr, setstateErr] = useState("");
  const [Durationthreeval, setDurationthreeval] = useState([]);
  const [LOne_user, setLoneusers] = useState([]);
  const [Ltwo_users, setLTwoUsers] = useState([]);
  const [LthreeUsers, setLthreeUsers] = useState([]);

  const [LOne_userErr, setLoneuserserr] = useState([]);
  const [Ltwo_usersErr, setLTwoUserserr] = useState([]);
  const [LthreeUsersErr, setLthreeUserserr] = useState([]);
  const [regionErro, setregionerr] = useState("");

  const [LOneUserOptions, setLoneOptions] = useState([]);
  const [Ltwooptions, setLtwoOptions] = useState([]);
  const [LthreeOptions, setLthreeOptions] = useState([]);

  const [L1TimeTypeErr, setL1TimeTypeErr] = useState("");
  const [L2TimeTypeErr, setL2TimeTypeErr] = useState("");
  const [L3TimeTypeErr, setL3TimeTypeErr] = useState("");

  const [L1UserTATErr, setL1UserTATErr] = useState("");
  const [L2UserTATErr, setL2UserTATErr] = useState("");
  const [L3UserTATErr, setL3UserTATErr] = useState("");
  const [clientNameEr, setClientNaaErr] = useState("");
  const [LonePersonsst, setLevelOnePersonst] = useState(true);
  const [LTwoPersonsst, setLevelTwoPersonst] = useState(true);
  const [LThreePersonsst, setLevelThreePersonst] = useState(true);
  const [ticketingRadioChecked, setTicketingChecked] = useState(true);
  const [multiselect, setMuliselect] = useState([]);

  const [ticketingPanIndiaRadioChecked, setTicketingPanIndiaChecked] =
    useState(false);
  let [nameList, setOptions] = useState([]);
  const [PasChec, setPassChe] = useState({ cheque: true, passbook: false });

  const handleRadioChangeticketing = () => {
    setTicketingPanIndiaChecked(!ticketingPanIndiaRadioChecked);
  };

  console.log(
    ticketingPanIndiaRadioChecked,
    "asiduaiosd ticketingPanIndiaRadioChecked"
  );
  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  ///------------REgion------------------
  useEffect(() => {
    // if the state is requried then , no need to add the region functionality , if not means , have to add
    if (data.state_id != undefined && data.state_id != "") {
      const payloads = {
        search: SearchedVal.regionSearch,
        page_size: 10,
        page: 1,
        counts: 1,
        state: data.state_id,
      };
      dispatch(setRegionActions(payloads));
    }
  }, [SearchedVal.regionSearch, data.state_id]);

  useEffect(() => {
    if (EditId != "" && EditId != undefined) {
      const payload = {
        EditId: EditId,
      };
      dispatch(setTheInternalDepartmentRetreve_usersActions(payload));
    }
  }, []);

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          usersearh: SearchDebounance.usersearh,
          categorySearch: SearchDebounance.categorySearch,
        });
      }
    },
    500,
    [SearchDebounance]
  );



  useEffect(() => {
    if (EditId != "" && EditId != undefined) {
      if (
        state.InternalDepartments_usersRetrivee
          .InternalDepartments_usersretrievedatas
      ) {
        let issuesIds = [];
        let userOne = [];
        let usertwo = [];
        let userthree = [];
        let L1userValues = [];
        let L2UserValues = [];
        let L3UserValues = [];
        let IssueObjects = [];

        state.InternalDepartments_usersRetrivee
          .InternalDepartments_usersretrievedatas.l1_user != undefined &&
          state.InternalDepartments_usersRetrivee
            .InternalDepartments_usersretrievedatas.l1_user.length > 0 &&
          state.InternalDepartments_usersRetrivee.InternalDepartments_usersretrievedatas.l1_user.map(
            (item) => {
              L1userValues.push({ value: item.id, label: item.first_name });

              userOne.push(item.id);
            }
          );

        state.InternalDepartments_usersRetrivee
          .InternalDepartments_usersretrievedatas.l2_user != undefined &&
          state.InternalDepartments_usersRetrivee
            .InternalDepartments_usersretrievedatas.l2_user.length > 0 &&
          state.InternalDepartments_usersRetrivee.InternalDepartments_usersretrievedatas.l2_user.map(
            (item) => {
              usertwo.push(item.id);
              L2UserValues.push({ value: item.id, label: item.first_name });
            }
          );

        state.InternalDepartments_usersRetrivee
          .InternalDepartments_usersretrievedatas.l3_user != undefined &&
          state.InternalDepartments_usersRetrivee
            .InternalDepartments_usersretrievedatas.l3_user.length > 0 &&
          state.InternalDepartments_usersRetrivee.InternalDepartments_usersretrievedatas.l3_user.map(
            (item) => {
              userthree.push(item.id);
              L3UserValues.push({ value: item.id, label: item.first_name });
            }
          );
        console.log(L3UserValues, "L3UserValues");

        setData({
          ...data,
          l1_user: userOne,
          l2_user: usertwo,
          l3_user: userthree,
          incharge_ids: userthree,
          l1_time_type:
            state.InternalDepartments_usersRetrivee
              .InternalDepartments_usersretrievedatas.l1_time_type,
          l2_time_type:
            state.InternalDepartments_usersRetrivee
              .InternalDepartments_usersretrievedatas.l2_time_type,
          l3_time_type:
            state.InternalDepartments_usersRetrivee
              .InternalDepartments_usersretrievedatas.l3_time_type,
          l1_user_TAT:
            state.InternalDepartments_usersRetrivee
              .InternalDepartments_usersretrievedatas.l1_user_TAT,
          l2_user_TAT:
            state.InternalDepartments_usersRetrivee
              .InternalDepartments_usersretrievedatas.l2_user_TAT,
          l3_user_TAT:
            state.InternalDepartments_usersRetrivee
              .InternalDepartments_usersretrievedatas.l3_user_TAT,
          region_id:
            state.InternalDepartments_usersRetrivee
              .InternalDepartments_usersretrievedatas.region_id?.id,
          state_id:
            state.InternalDepartments_usersRetrivee
              .InternalDepartments_usersretrievedatas.state_id?.id,
        });
        setLthreeUsers(L3UserValues);
        setLTwoUsers(L2UserValues);
        setLoneusers(L1userValues);
        setPassChe({
          ...PasChec,
          passbook:
            state.InternalDepartments_usersRetrivee
              .InternalDepartments_usersretrievedatas.pan_india == true
              ? true
              : false,
          cheque:
            state.InternalDepartments_usersRetrivee
              .InternalDepartments_usersretrievedatas.pan_india == false
              ? true
              : false,
        });
        setTicketingPanIndiaChecked(
          state.InternalDepartments_usersRetrivee
            .InternalDepartments_usersretrievedatas.pan_india
        );
        if (
          state.InternalDepartments_usersRetrivee
            .InternalDepartments_usersretrievedatas.region_id != null
        ) {
          setregionValues({
            value:
              state.InternalDepartments_usersRetrivee
                .InternalDepartments_usersretrievedatas.region_id?.id,
            label:
              state.InternalDepartments_usersRetrivee
                .InternalDepartments_usersretrievedatas.region_id?.region_name,
          });
        }
        if (
          state.InternalDepartments_usersRetrivee
            .InternalDepartments_usersretrievedatas.state_id != null
        ) {
          setMuliselect({
            value:
              state.InternalDepartments_usersRetrivee
                .InternalDepartments_usersretrievedatas.state_id?.id,
            label:
              state.InternalDepartments_usersRetrivee
                .InternalDepartments_usersretrievedatas.state_id?.state_name,
          });
        }

        if (
          state.InternalDepartments_usersRetrivee
            .InternalDepartments_usersretrievedatas.l1_time_type != null &&
          state.InternalDepartments_usersRetrivee
            .InternalDepartments_usersretrievedatas.l2_time_type != null &&
          state.InternalDepartments_usersRetrivee
            .InternalDepartments_usersretrievedatas.l3_time_type != null
        ) {
          setDurationoneval({
            value:
              state.InternalDepartments_usersRetrivee
                .InternalDepartments_usersretrievedatas.l1_time_type,
            label:
              state.InternalDepartments_usersRetrivee
                .InternalDepartments_usersretrievedatas.l1_time_type == 0
                ? "Minutes"
                : state.InternalDepartments_usersRetrivee
                    .InternalDepartments_usersretrievedatas.l1_time_type == 1
                ? "Hours"
                : state.InternalDepartments_usersRetrivee
                    .InternalDepartments_usersretrievedatas.l1_time_type == 2 &&
                  "Day",
          });

          setDurationtwoval({
            value:
              state.InternalDepartments_usersRetrivee
                .InternalDepartments_usersretrievedatas.l2_time_type,
            label:
              state.InternalDepartments_usersRetrivee
                .InternalDepartments_usersretrievedatas.l2_time_type == 0
                ? "Minutes"
                : state.InternalDepartments_usersRetrivee
                    .InternalDepartments_usersretrievedatas.l2_time_type == 1
                ? "Hours"
                : state.InternalDepartments_usersRetrivee
                    .InternalDepartments_usersretrievedatas.l2_time_type == 2 &&
                  "Day",
          });
          setDurationthreeval({
            value:
              state.InternalDepartments_usersRetrivee
                .InternalDepartments_usersretrievedatas.l3_time_type,
            label:
              state.InternalDepartments_usersRetrivee
                .InternalDepartments_usersretrievedatas.l3_time_type == 0
                ? "Minutes"
                : state.InternalDepartments_usersRetrivee
                    .InternalDepartments_usersretrievedatas.l3_time_type == 1
                ? "Hours"
                : state.InternalDepartments_usersRetrivee
                    .InternalDepartments_usersretrievedatas.l3_time_type == 2 &&
                  "Day",
          });
        }
      }
    }
  }, [
    state.InternalDepartments_usersRetrivee
      .InternalDepartments_usersretrievedatas,
  ]);

  ///---user--manager-----------
  useEffect(() => {
    const payload = {
      search: SearchedVal.usersearh,
      page_size: 10,
      page: 1,
      white_collar: true,
      state: data.state_id,
      region: data.region_id,
      // zone: data.zone_id
    };
    dispatch(setUserActions(payload));
  }, [SearchedVal.usersearh, data.region_id, data.state_id]);

  useEffect(() => {
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name,
        });
      });
      setOptions2(objectArray);
    }
  }, [SearchedVal.regionSearch, state.regioncall.RegionDat, data.state_id]);
  ///--------------------State----------------------
  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState, SearchedVal.stateSearch]);
  useEffect(() => {
    if (state.Usergetlists.UserList !== undefined) {
      let ObjectArrayFormager = [];
      state.Usergetlists.UserList.forEach((element) => {
        if (!data.l1_user.includes(String(element.id)) && !data.l2_user.includes(String(element.id)) && !data.l3_user.includes(String(element.id))) {
        ObjectArrayFormager.push({
          value: element.id,
          label: element.first_name,
        });
        }
      });

      setLoneOptions(ObjectArrayFormager);
    }
  }, [
    state.Usergetlists.UserList,
    SearchedVal.usersearh,
    data.l1_user,
    data.l2_user,
    data.l3_user,
    data.region_id,
  ]);
  useEffect(() => {
    if (state.Usergetlists.UserList !== undefined) {
      let ObjectArrayFormager = [];
      state.Usergetlists.UserList.forEach((element) => {
        if (!data.l1_user.includes(String(element.id)) && !data.l3_user.includes(String(element.id))) {
        ObjectArrayFormager.push({
          value: element.id,
          label: element.first_name,
        });
        }
      });

      setLtwoOptions(ObjectArrayFormager);
    }
  }, [
    state.Usergetlists.UserList,
    SearchedVal.usersearh,
    data.l1_user,
    data.region_id,
  ]);

  useEffect(() => {
    if (state.Usergetlists.UserList !== undefined) {
      let ObjectArrayFormager = [];

      state.Usergetlists.UserList.forEach((element) => {
        if (
          !data.l1_user.includes(String(element.id)) &&
          !data.l2_user.includes(String(element.id))
        ) {
        ObjectArrayFormager.push({
          value: element.id,
          label: element.first_name,
        });
        }
      });
      setLthreeOptions(ObjectArrayFormager);
    }
  }, [
    state.Usergetlists.UserList,
    SearchedVal.usersearh,
    data.l1_user,
    data.l2_user,
    data.region_id,
  ]);

  const customStyles = {
    control: (base) => ({
      ...base,
      border: "1px solid #ced4da",
      borderRadius: "5px",
      // padding: "5px",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#d8e2fb",
      borderRadius: "20px",
      padding: "5px",
      color: "#234492",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#234492",
      fontWeight: "bold",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#234492",
      cursor: "pointer",
      ":hover": {
        color: "#FF0000",
      },
    }),
  };
  const preventScrollNumbers = (e) => {
    e.preventDefault();
  };
  const handleInputuser = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      usersearh: Val,
    });
  };

  const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setregionValues([]);
      // let L1userValues = [];
      // let L2UserValues = [];
      // let L3UserValues = [];
      // let userOne = [];
      // let usertwo = [];
      // let userthree = []
      setData({
        ...data,
        state_id: selectedVal.value,
        region_id: "",
        // l1_user: userOne,
        // l2_user: usertwo,
        // l3_user: userthree,
        // incharge_ids: userthree,
      });
      // setLthreeUsers(L3UserValues);
      // setLTwoUsers(L2UserValues);
      // setLoneusers(L1userValues);
    } else {
      setMuliselect([]);
      setregionValues([]);
      // let L1userValues = [];
      // let L2UserValues = [];
      // let L3UserValues = [];
      // let userOne = [];
      // let usertwo = [];
      // let userthree = []
      setData({
        ...data,
        state_id: "",
        region_id: "",
        // l1_user: userOne,
        // l2_user: usertwo,
        // l3_user: userthree,
        // incharge_ids: userthree,
      });
      // setLthreeUsers(L3UserValues);
      // setLTwoUsers(L2UserValues);
      // setLoneusers(L1userValues);
    }
  };
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };

  const HandleChanges = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleLoneUsers = (e) => {
    if (e != null) {
      let objectAi = [];

      setLoneusers(e);
      e.map((item) => {
        objectAi.push(item.value);
      });
      setData({
        ...data,
        l1_user: objectAi,
      });
    }
  };

  useEffect(() => {
    if (ticketingPanIndiaRadioChecked == true) {
      HandleRegionlist(null);
      setregionerr("");
      handleSelectChange(null);
      setstateErr("");
    }
  }, [ticketingPanIndiaRadioChecked]);

  const HandleRegionlist = (e) => {
    if (e != null) {
      setregionValues(e);
      // let L1userValues = [];
      // let L2UserValues = [];
      // let L3UserValues = [];
      // let userOne = [];
      // let usertwo = [];
      // let userthree = []
      setData({
        ...data,
        region_id: e.value,
        // l1_user: userOne,
        // l2_user: usertwo,
        // l3_user: userthree,
        // incharge_ids: userthree,
        // l1_time_type:"",
        // l2_time_type: "",
        // l3_time_type: "",
        // l1_user_TAT: "",
        // l2_user_TAT: "",
        // l3_user_TAT: "",
      });

      // setLthreeUsers(L3UserValues);
      // setLTwoUsers(L2UserValues);
      // setLoneusers(L1userValues);
    } else {
      setregionValues([]);

      setData({
        ...data,
        region_id: "",
      });
    }
  };
  const getInitials = (name) => {
    return name
      .replace(/\d+/g, "") // Remove any numbers
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  const handleRemove = (itemToRemove) => {
    setLoneusers((prev) =>
      prev.filter((item) => item.value !== itemToRemove.value)
    );
    const updatedLoneusers = LOne_user.filter(
      (item) => item.value !== itemToRemove.value
    ).map((item) => item.value); // Extract only the value properties

    setData({
      ...data,
      l1_user: updatedLoneusers,
    });
  };
  const capitalizeEachWord = (str) => {
    return str && typeof str === "string"
      ? str
          .split(" ") // Split the string into an array of words
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          ) // Capitalize each word
          .join(" ") // Join the words back into a string
      : ""; // Return an empty string if the input is invalid
  };
  const handleLTwoUsers = (e) => {
    if (e != null) {
      let objectAi = [];
      setLTwoUsers(e);

      e.map((item) => {
        objectAi.push(item.value);
      });
      setData({
        ...data,
        l2_user: objectAi,
      });
    }
  };
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };
  const handleRemoveperson2 = (itemToRemove) => {
    setLTwoUsers((prev) =>
      prev.filter((item) => item.value !== itemToRemove.value)
    );
    const updatedLoneusers = Ltwo_users.filter(
      (item) => item.value !== itemToRemove.value
    ).map((item) => item.value); // Extract only the value properties

    setData({
      ...data,
      l2_user: updatedLoneusers,
    });
  };

  const handleRemoveperson3 = (itemToRemove) => {
    setLthreeUsers((prev) =>
      prev.filter((item) => item.value !== itemToRemove.value)
    );
    const updatedLoneusers = LthreeUsers.filter(
      (item) => item.value !== itemToRemove.value
    ).map((item) => item.value); // Extract only the value properties

    setData({
      ...data,
      l3_user: updatedLoneusers,
    });
  };

  const HandleTheDurations = (e, Names) => {
    if (Names == "l3time_type") {
      setDurationthreeval(e);
      setData({
        ...data,
        l3_time_type: e.value,
      });
    } else if (Names == "l2time_type") {
      setDurationtwoval(e);
      setData({
        ...data,
        l2_time_type: e.value,
      });
    } else if (Names == "l1time_type") {
      setDurationoneval(e);
      setData({
        ...data,
        l1_time_type: e.value,
      });
    }
  };

  const handleLThreeUsers = (e) => {
    if (e != null) {
      let objectAi = [];
      setLthreeUsers(e);
      e.map((item) => {
        objectAi.push(item.value);
      });
      setData({
        ...data,
        l3_user: objectAi,
      });
    }
  };

  const HandleSubmit = (e) => {
    var a = 0;
    // if (data.l1_time_type === "") {
    //     setL1TimeTypeErr("*Type is required");
    //     a = 1;
    // }

    // if (data.l2_time_type === "") {
    //     setL2TimeTypeErr("*Type is required");
    //     a = 1;
    // }

    // if (data.l3_time_type === "") {
    //     setL3TimeTypeErr("*Type is required");
    //     a = 1;
    // }

    // if (data.l1_user_TAT === "") {
    //     setL1UserTATErr("*TAT is required");
    //     a = 1;
    // }

    // if (data.l2_user_TAT === "") {
    //     setL2UserTATErr("*TAT is required");
    //     a = 1;
    // }

    // if (data.l3_user_TAT === "") {
    //     setL3UserTATErr("*TAT is required");
    //     a = 1;
    // }

    // if (data.l1_user.length == 0) {
    //     setLoneuserserr("*L1 Persons are requried");
    //     a = 1;
    // }

    // if (data.l2_user.length == 0) {
    //     setLTwoUserserr("*L2 Persons are requried");
    //     a = 1;
    // }

    // if (data.l3_user.length == 0) {
    //     setLthreeUserserr("*L3 Persons are requried");
    //     a = 1;
    // }

    // if (data.l1_user.length == 0 || data.l1_time_type == "" || data.l1_user_TAT == "") {
    //     setLevelOnePersonst(true)
    // }

    // if (data.l2_user.length == 0 || data.l2_time_type == "" || data.l2_user_TAT == "") {
    //     setLevelTwoPersonst(true)
    // }

    // if (data.l3_user.length == 0 || data.l3_time_type == "" || data.l3_user_TAT == "") {
    //     setLevelThreePersonst(true)
    // }
    // if (ticketingPanIndiaRadioChecked == false) {
    //     if (data.region_id == "") {
    //         setregionerr("*Region is requried");
    //         a = 1;
    //     }
    //     if (data.state_id == "") {
    //         setstateErr("*State is requried");
    //         a = 1;
    //     }
    // }

    let errors = [];

    if (data.l1_time_type === "") {
      // setL1TimeTypeErr("*Type is required");
      a = 1;
      errors.push("L1 Time Type is required");
    }

    if (data.l2_time_type === "") {
      // setL2TimeTypeErr("*Type is required");
      a = 1;

      errors.push("L2 Time Type is required");
    }

    if (data.l3_time_type === "") {
      // setL3TimeTypeErr("*Type is required");
      a = 1;

      errors.push("L3 Time Type is required");
    }

    if (data.l1_user_TAT === "") {
      // setL1UserTATErr("*TAT is required");
      a = 1;

      errors.push("L1 User TAT is required");
    }

    if (data.l2_user_TAT === "") {
      // setL2UserTATErr("*TAT is required");
      a = 1;

      errors.push("L2 User TAT is required");
    }

    if (data.l3_user_TAT === "") {
      // setL3UserTATErr("*TAT is required");
      a = 1;

      errors.push("L3 User TAT is required");
    }

    if (data.l1_user.length === 0) {
      // setLoneuserserr("*L1 Persons are required");
      a = 1;

      errors.push("L1 Persons are required");
    }

    if (data.l2_user.length === 0) {
      // setLTwoUserserr("*L2 Persons are required");
      a = 1;

      errors.push("L2 Persons are required");
    }

    if (data.l3_user.length === 0) {
      // setLthreeUserserr("*L3 Persons are required");
      a = 1;

      errors.push("L3 Persons are required");
    }

    if (
      data.l1_user.length === 0 ||
      data.l1_time_type === "" ||
      data.l1_user_TAT === ""
    ) {
      setLevelOnePersonst(true);
    }

    if (
      data.l2_user.length === 0 ||
      data.l2_time_type === "" ||
      data.l2_user_TAT === ""
    ) {
      setLevelTwoPersonst(true);
    }

    if (
      data.l3_user.length === 0 ||
      data.l3_time_type === "" ||
      data.l3_user_TAT === ""
    ) {
      setLevelThreePersonst(true);
    }

    if (!ticketingPanIndiaRadioChecked) {
      if (data.region_id === "") {
        // setregionerr("*Region is required");
        a = 1;

        errors.push("Region is required");
      }
      if (data.state_id === "") {
        // setstateErr("*State is required");
        a = 1;

        errors.push("State is required");
      }
    }
    console.log(errors, "slkalks errors", a);

    // Show a single toast if there are any errors
    if (errors.length > 0) {
      toast.error("Please enter valid data");
      return;
    }

    if (a == 0) {
      if (EditId == "") {
        const payload = {
          data: {
            l1_user: data.l1_user,
            l2_user: data.l2_user,
            l3_user: data.l3_user,
            l1_time_type: data.l1_time_type,
            l2_time_type: data.l2_time_type,
            l3_time_type: data.l3_time_type,

            l1_user_TAT: data.l1_user_TAT,
            l2_user_TAT: data.l2_user_TAT,
            l3_user_TAT: data.l3_user_TAT,
            // issue_ids: data.issue_ids,
            incharge_ids: data.l3_user,
            region_id: data.region_id,
            department_id: state.NeededdatasListed.SubQueryIDs,
            pan_india: ticketingPanIndiaRadioChecked,
            state_id: data.state_id,
          },
          currentPage: currentPage,
          search: getsearch,
          user_type: LevelUsersSelected,
        };
        dispatch(
          setTheInternalDepartmentlevelusersCreatedActions(
            payload,
            setShow(false)
          )
        );
      } else {
        const payload = {
          data: {
            l1_user: data.l1_user,
            l2_user: data.l2_user,
            l3_user: data.l3_user,
            l1_time_type: data.l1_time_type,
            l2_time_type: data.l2_time_type,
            l3_time_type: data.l3_time_type,

            l1_user_TAT: data.l1_user_TAT,
            l2_user_TAT: data.l2_user_TAT,
            l3_user_TAT: data.l3_user_TAT,
            // issue_ids: data.issue_ids,
            incharge_ids: data.l3_user,
            region_id: data.region_id,
            department_id: state.NeededdatasListed.SubQueryIDs,
            pan_india: ticketingPanIndiaRadioChecked,
            state_id: data.state_id,
          },
          currentPage: currentPage,
          search: getsearch,
          EditId: EditId,
          user_type: LevelUsersSelected,
        };

        dispatch(
          setTheInternalDepartmentEdtions_usersActions(payload, setShow(false))
        );
      }
    }
  };

  ////---PassBook-------or -------------cheque----changes---
  const handlePassBookChnages = (e, name, value, values) => {
    setPassChe({
      ...PasChec,
      cheque: value,
      passbook: values,
    });
  };
  return (
    <div className="RoleCreatePopup">
      <div className="BeforePopUp">
        <div
          className="RolePopups"
          style={{ width: "45%", borderRadius: "25px" }}
        >
          <div className="asds" style={{ borderRadius: "25px" }}>
            <div
              class="ModalHeader ModalHeaderAddusers"
              style={{ background: "#fff", borderBottom: "none !important" }}
            >
              <span className="AddUserPopups"> Add Users </span>

              <div className="CloseIcon" onClick={(e) => setShow(false)}>
                {/* <CloseOutlinedIcon /> */}
                <img
                  src={closebtnimg}
                  style={{ width: "30px", height: "30px", marginRight: "15px" }}
                />
              </div>
            </div>

            <div className="Modal-Body Modal-bodyUserCRUD">
              <>
                <div className="col-12">
                  <div
                    className="col-12 mt-3 "
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <label for="validationCustom01" class="form-label">
                      {/* <div
                                                className="col-12 LeaveButtonVeirif"
                                                style={{
                                                    width: "100%"
                                                }}
                                            >
                                                <div className="InnerChoicesDATA"
                                                    style={{
                                                        width: "100%"
                                                    }}
                                                >
                                                    <label className="BranchButton">

                                                        <span>Pan India</span>
                                                    </label>

                                                    <div>
                                                        <label>
                                                            <input
                                                                className="form-check-input custom-radioRegurlarization"
                                                                type="checkbox"
                                                                checked={ticketingPanIndiaRadioChecked}
                                                                onChange={handleRadioChangeticketing}
                                                            />
                                                            Yes   </label>
                                                        <label>
                                                            <input
                                                                className="form-check-input custom-radioRegurlarization"
                                                                type="checkbox"
                                                                checked={ticketingPanIndiaRadioChecked}
                                                                onChange={handleRadioChangeticketing}
                                                            />
                                                            No   </label>
                                                    </div>
                                                </div>
                                            </div> */}

                      <div
                        style={{
                          width: "409px",
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          flexDirection: "column",
                        }}
                      >
                        <div>
                          <p style={{ fontWeight: "500" }}>Pan India</p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            padding: "0px 20px",
                            width: "100%",
                          }}
                        >
                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "flex-start",
                              flexDirection: "row",
                            }}
                          >
                            <input
                              // class="form-check-input"
                              className="form-check-input  radioRegurlarization"
                              type="checkbox"
                              onChange={(e) => {
                                setTicketingPanIndiaChecked(false);
                                handlePassBookChnages(
                                  e,
                                  "cheque ",
                                  true,
                                  false
                                );
                              }}
                              checked={PasChec.cheque}
                              style={{ cursor: "pointer" }}
                            />
                            No
                          </label>

                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ width: "100%" }}
                          >
                            <input
                              // class="form-check-input"
                              className="form-check-input  radioRegurlarization"
                              type="checkbox"
                              onChange={(e) => {
                                setTicketingPanIndiaChecked(true);
                                handlePassBookChnages(
                                  e,
                                  "passbook",
                                  false,
                                  true
                                );
                              }}
                              checked={PasChec.passbook}
                              style={{ cursor: "pointer" }}
                            />
                            Yes
                          </label>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-12" style={{ display: "flex" }}>
                  <div className="col-6 mt-3">
                    <label for="validationCustom01" class="form-label">
                      State
                      {ticketingPanIndiaRadioChecked == false && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </label>
                    <Select
                      className="Selects "
                      styles={{ position: "relative", top: "60px" }}
                      onChange={(e) => {
                        handleSelectChange(e);
                        setstateErr("");
                      }}
                      onInputChange={handleInputChange}
                      options={nameList}
                      value={multiselect}
                      isDisabled={ticketingPanIndiaRadioChecked == true}
                      labelledBy="Select"
                    />
                    <p className="Error">{stateEr}</p>
                  </div>

                  <div className="col-6 mt-3">
                    <label for="validationCustom01" class="form-label">
                      Region
                      {ticketingPanIndiaRadioChecked == false && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </label>
                    <Select
                      value={regionValues}
                      options={RegionOptions}
                      onChange={(e) => {
                        HandleRegionlist(e);
                        setregionerr("");
                      }}
                      onInputChange={(e) => {
                        handleInputRegion(e);
                      }}
                      isDisabled={ticketingPanIndiaRadioChecked == true}
                    />
                    <p className="Error">{regionErro}</p>
                  </div>
                </div>

                <div className="col-12">
                  <div className="col-12  md-4  mt-3">
                    <div
                      className="MatrixListhide col-12"
                      onClick={() => {
                        setLevelOnePersonst(!LonePersonsst);
                      }}
                    >
                      <span>L1</span>
                      <img src={dropdownimg} />
                    </div>
                    {LonePersonsst && (
                      <>
                        <div className="LevelListeds col-12">
                          <div className="col-sm-6 ">
                            <label for="validationCustom01" class="form-label">
                              Person
                              {ticketingRadioChecked == true && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <Select
                              // className="Selects RegionNames"
                              styles={customStyles}
                              onChange={(e) => {
                                handleLoneUsers(e);
                                setLoneuserserr("");
                              }}
                              options={LOneUserOptions}
                              labelledBy="Select"
                              isMulti
                              value={LOne_user}
                              onInputChange={handleInputuser}
                              // isDisabled={ticketingRadioChecked == false}
                            />

                            <p className="Error">{LOne_userErr}</p>
                          </div>

                          <div
                            className="col-6"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div className=" col-sm-5  ValidityData">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Type
                                {ticketingRadioChecked == true && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                              </label>
                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                options={DurationOpions}
                                labelledBy="Select"
                                onChange={(e) => {
                                  HandleTheDurations(e, "l1time_type");
                                  setL1TimeTypeErr("");
                                }}
                                value={DurationOneval}
                                style={{ zIndex: "99" }}
                                // isDisabled={ticketingRadioChecked == false}
                              />
                              <p className="Error">{L1TimeTypeErr}</p>
                            </div>
                            <div className=" col-sm-5  ValidityData">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                TAT
                                {ticketingRadioChecked == true && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                              </label>
                              <input
                                className="form-control"
                                id="firstName"
                                name="l1_user_TAT"
                                value={data.l1_user_TAT}
                                // disabled={ticketingRadioChecked == false}

                                autoComplete="off"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                  const minutesRegex = /^([1-9]|[1-5][0-9])$/;

                                  if (data.l1_time_type == "0") {
                                    if (
                                      minutesRegex.test(value) ||
                                      value === ""
                                    ) {
                                      HandleChanges(e);
                                      setL1UserTATErr("");
                                    }
                                  } else if (
                                    phoneRegex.test(value) ||
                                    value === ""
                                  ) {
                                    HandleChanges(e);
                                    setL1UserTATErr("");
                                  }
                                }}
                              />
                              <p className="Error">{L1UserTATErr}</p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="col-12 md-4 ">
                    <div
                      className="MatrixListhide col-12"
                      onClick={() => {
                        setLevelTwoPersonst(!LTwoPersonsst);
                      }}
                    >
                      <span>L2</span>
                      <img src={dropdownimg} />
                    </div>
                    {LTwoPersonsst && (
                      <>
                        <div className="LevelListeds col-12">
                          <div className="col-6 ">
                            <label for="validationCustom01" class="form-label">
                              Person
                              {ticketingRadioChecked == true && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <Select
                              // className="Selects "
                              styles={customStyles}
                              onChange={(e) => {
                                handleLTwoUsers(e);
                                setLTwoUserserr("");
                              }}
                              options={Ltwooptions}
                              labelledBy="Select"
                              isMulti
                              value={Ltwo_users}
                              onInputChange={handleInputuser}
                              isDisabled={
                                // data.l1_user != null && data.l1_user != undefined &&
                                data.l1_user == null ||
                                data.l1_user == undefined ||
                                data.l1_user.length == 0
                                // ||
                                // ticketingRadioChecked == false
                              }
                            />
                            <p className="Error">{Ltwo_usersErr}</p>
                          </div>

                          <div
                            className="col-6"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div className=" col-sm-5  ValidityData">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Type
                                {ticketingRadioChecked == true && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                              </label>
                              <Select
                                className="Selects "
                                styles={{ position: "relative", top: "60px" }}
                                options={DurationOpions}
                                labelledBy="Select"
                                onChange={(e) => {
                                  HandleTheDurations(e, "l2time_type");
                                  setL2TimeTypeErr("");
                                }}
                                value={DurationTwoval}
                                style={{ zIndex: "99" }}
                                // isDisabled={ticketingRadioChecked == false}
                              />
                              <p className="Error">{L2TimeTypeErr}</p>
                            </div>

                            <div className=" col-sm-5  ValidityData">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                TAT
                                {ticketingRadioChecked == true && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                              </label>
                              <input
                                className="form-control"
                                id="firstName"
                                name="l2_user_TAT"
                                value={data.l2_user_TAT}
                                autoComplete="off"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                  const minutesRegex = /^([1-9]|[1-5][0-9])$/;

                                  if (data.l2_time_type == "0") {
                                    if (
                                      minutesRegex.test(value) ||
                                      value === ""
                                    ) {
                                      HandleChanges(e);
                                      setL2UserTATErr("");
                                    }
                                  } else if (
                                    phoneRegex.test(value) ||
                                    value === ""
                                  ) {
                                    HandleChanges(e);
                                    setL2UserTATErr("");
                                  }
                                }}
                                // disabled={ticketingRadioChecked == false}
                              />
                              <p className="Error">{L2UserTATErr}</p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="col-12 md-4 ">
                    <div
                      className="MatrixListhide"
                      onClick={() => {
                        setLevelThreePersonst(!LThreePersonsst);
                      }}
                    >
                      <span>L3</span>
                      <img src={dropdownimg} />
                    </div>
                    {LThreePersonsst && (
                      <>
                        <div className="LevelListeds col-12">
                          <div className="col-6 ">
                            <label for="validationCustom01" class="form-label">
                              Person
                              {ticketingRadioChecked == true && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <Select
                              // className="Selects "
                              menuPlacement="top"
                              styles={customStyles}
                              onChange={(e) => {
                                handleLThreeUsers(e);
                                setLthreeUserserr("");
                              }}
                              options={LthreeOptions}
                              labelledBy="Select"
                              isMulti
                              value={
                                ticketingRadioChecked == false
                                  ? []
                                  : LthreeUsers
                              }
                              onInputChange={handleInputuser}
                              isDisabled={
                                // data.l1_user != null && data.l1_user != undefined &&
                                data.l1_user == null ||
                                data.l1_user == undefined ||
                                data.l1_user.length == 0 ||
                                data.l2_user == null ||
                                data.l2_user == undefined ||
                                data.l2_user.length == 0
                                // ||
                                // ticketingRadioChecked == false
                              }
                            />
                            <p className="Error">{LthreeUsersErr}</p>
                          </div>

                          <div
                            className="col-6"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div className=" col-sm-5  ValidityData">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Type
                                {ticketingRadioChecked == true && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                              </label>
                              <Select
                                className="Selects "
                                styles={{ position: "relative", top: "60px" }}
                                options={DurationOpions}
                                labelledBy="Select"
                                onChange={(e) => {
                                  HandleTheDurations(e, "l3time_type");
                                  setL3TimeTypeErr("");
                                }}
                                // isDisabled={ticketingRadioChecked == false}

                                value={Durationthreeval}
                              />
                              <p className="Error">{L3TimeTypeErr}</p>
                            </div>

                            <div className=" col-sm-5  ValidityData">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                TAT
                                {ticketingRadioChecked == true && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                              </label>
                              <input
                                className="form-control"
                                id="firstName"
                                name="l3_user_TAT"
                                value={data.l3_user_TAT}
                                autoComplete="off"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                  const minutesRegex = /^([1-9]|[1-5][0-9])$/;

                                  // if ((phoneRegex.test(value) || value === '')) {
                                  //   HandleChanges(e);
                                  //   setL3UserTATErr("")
                                  // }

                                  if (data.l3_time_type == "0") {
                                    if (
                                      minutesRegex.test(value) ||
                                      value === ""
                                    ) {
                                      HandleChanges(e);
                                      setL3UserTATErr("");
                                    }
                                  } else if (
                                    phoneRegex.test(value) ||
                                    value === ""
                                  ) {
                                    HandleChanges(e);
                                    setL3UserTATErr("");
                                  }
                                }}
                                // disabled={ticketingRadioChecked == false}
                              />

                              <p className="Error">{L3UserTATErr}</p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            </div>

            <div
              className="RoleButton"
              style={{
                display: "flex",
                gap: "15px",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "30px",
                marginBottom: "20px",
                padding: "0px 40px",
              }}
            >
              <button
                class="btn CancelBtn"
                onClick={(e) => {
                  setShow(false);
                }}
              >
                Cancel
              </button>
              <button
                class="btn  SaveBtn"
                type="submit"
                onClick={(e) => {
                  HandleSubmit(e);
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepartmentLevelUser;
